import { IAction, KEEP_THE_SAME, StateStatus } from 'redux/utils/common';
import * as Types from './types';
import { IPictureInfo } from 'services/api/picture';
import { IDocument } from 'constants/document';

interface IDataCaption {
  id: number;
  caption: string;
}
export interface IState {
  productDocuments: {
    data: Array<IDocument>;
    status: StateStatus | null | undefined;
  };
  insertProductDocumentStatus: StateStatus | null | undefined;
  selectedDocuments: Array<number>;
  rearrangeDocumentsStatus: StateStatus | null | undefined;
  updateDocumentVisibilityStatus: StateStatus | null | undefined;
  deleteDocumentStatus: StateStatus | null | undefined;
  documentInfo: {
    data: IPictureInfo | null;
    status: StateStatus | null | undefined;
  };
  updateDocumentInfo: StateStatus | null | undefined;
  captionDocument: IDataCaption[] | null;
  updateCaptionDocument: StateStatus | null | undefined;
}

const initialState: IState = {
  productDocuments: {
    data: [],
    status: null,
  },
  insertProductDocumentStatus: null,
  selectedDocuments: [],
  rearrangeDocumentsStatus: null,
  updateDocumentVisibilityStatus: null,
  deleteDocumentStatus: null,
  documentInfo: {
    data: null,
    status: null,
  },
  updateDocumentInfo: null,
  captionDocument: null,
  updateCaptionDocument: null,
};

const PropertyDocumentsReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_PRODUCT_DOCUMENTS:
      return {
        ...state,
        productDocuments: {
          ...state.productDocuments,
          data:
            action.data === KEEP_THE_SAME
              ? state.productDocuments.data
              : action.data,
          status: action.status,
        },
      };
    case Types.INSERT_PRODUCT_DOCUMENT:
      return {
        ...state,
        insertProductDocumentStatus: action.status,
      };
    case Types.SET_SELECTED_DOCUMENT:
      return {
        ...state,
        selectedDocuments: action.data,
      };
    case Types.REARRANGE_DOCUMENTS:
      return {
        ...state,
        productDocuments: {
          ...state.productDocuments,
          data:
            action.data === KEEP_THE_SAME
              ? state.productDocuments.data
              : action.data,
        },
        rearrangeDocumentsStatus: action.status,
      };
    case Types.UPDATE_DOCUMENT_VISIBILITY:
      return {
        ...state,
        updateDocumentVisibilityStatus: action.status,
      };
    case Types.DELETE_DOCUMENT:
      return {
        ...state,
        deleteDocumentStatus: action.status,
      };
    case Types.SET_DOCUMENT_INFO:
      return {
        ...state,
        documentInfo: {
          data:
            action.data === KEEP_THE_SAME
              ? state.documentInfo.data
              : action.data,
          status: action.status,
        },
      };
    case Types.UPDATE_DOCUMENT_INFO:
      return {
        ...state,
        updateDocumentInfo: action.status,
      };
    case Types.SET_CAPTION_DOCUMENT:
      const stateCaptionDocument = state.captionDocument;
      const captionDocumentFilter = stateCaptionDocument?.filter(
        (item) => item.id !== action.data?.id
      );
      return {
        ...state,
        captionDocument: captionDocumentFilter
          ? [...captionDocumentFilter, action.data]
          : [action.data],
      };
    case Types.RESET_CAPTION_DOCUMENT:
      return {
        ...state,
        captionDocument: null,
      };

    case Types.UPDATE_CAPTION_DOCUMENT:
      return {
        ...state,
        updateCaptionDocument: action.status,
      };

    case Types.RESET_SELECTED_DOCUMENT:
      return {
        ...state,
        selectedDocuments: [],
      };

    default:
      return {
        ...state,
      };
  }
};

export default PropertyDocumentsReducer;
